// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "amount_off": {
      "column": null,
      "name": "amount_off",
      "selected_by_default": null,
      "translated": null
    },
    "currency": {
      "column": {
        "default": null,
        "name": "currency",
        "null": true,
        "type": "string"
      },
      "name": "currency",
      "selected_by_default": null,
      "translated": null
    },
    "duration": {
      "column": {
        "default": null,
        "name": "duration",
        "null": true,
        "type": "string"
      },
      "name": "duration",
      "selected_by_default": null,
      "translated": null
    },
    "duration_in_months": {
      "column": {
        "default": null,
        "name": "duration_in_months",
        "null": true,
        "type": "integer"
      },
      "name": "duration_in_months",
      "selected_by_default": null,
      "translated": null
    },
    "max_redemptions": {
      "column": {
        "default": null,
        "name": "max_redemptions",
        "null": true,
        "type": "integer"
      },
      "name": "max_redemptions",
      "selected_by_default": null,
      "translated": null
    },
    "percent_off": {
      "column": {
        "default": null,
        "name": "percent_off",
        "null": true,
        "type": "integer"
      },
      "name": "percent_off",
      "selected_by_default": null,
      "translated": null
    },
    "redeem_by": {
      "column": {
        "default": null,
        "name": "redeem_by",
        "null": true,
        "type": "datetime"
      },
      "name": "redeem_by",
      "selected_by_default": null,
      "translated": null
    },
    "times_redeemed": {
      "column": {
        "default": null,
        "name": "times_redeemed",
        "null": true,
        "type": "integer"
      },
      "name": "times_redeemed",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_valid": {
      "column": {
        "default": null,
        "name": "stripe_valid",
        "null": true,
        "type": "boolean"
      },
      "name": "stripe_valid",
      "selected_by_default": null,
      "translated": null
    },
    "created": {
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      },
      "name": "created",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_id": {
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      },
      "name": "stripe_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "StripeCoupon",
  "collectionKey": "stripe_coupons",
  "collectionName": "stripe_coupons",
  "i18nKey": "stripe_coupon",
  "camelizedLower": "stripeCoupon",
  "name": "StripeCoupon",
  "nameDasherized": "stripe-coupon",
  "pluralName": "stripe_coupons",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "StripeDiscount",
      "collectionName": "stripe_discounts",
      "foreignKey": "stripe_coupon_id",
      "name": "stripe_discounts",
      "macro": "has_many",
      "resource_name": "StripeDiscount",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "amount_off_cents",
      "column": {
        "default": null,
        "name": "amount_off_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "amount_off_currency",
      "column": {
        "default": null,
        "name": "amount_off_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created",
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "currency",
      "column": {
        "default": null,
        "name": "currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "duration",
      "column": {
        "default": null,
        "name": "duration",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "duration_in_months",
      "column": {
        "default": null,
        "name": "duration_in_months",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "livemode",
      "column": {
        "default": "1",
        "name": "livemode",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "max_redemptions",
      "column": {
        "default": null,
        "name": "max_redemptions",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "percent_off",
      "column": {
        "default": null,
        "name": "percent_off",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "redeem_by",
      "column": {
        "default": null,
        "name": "redeem_by",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "stripe_valid",
      "column": {
        "default": null,
        "name": "stripe_valid",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "times_redeemed",
      "column": {
        "default": null,
        "name": "times_redeemed",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "stripe_coupon",
  "primaryKey": "id"
}

/** Frontend model for StripeCoupon. */
export default class StripeCoupon extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  amountOff() {
    return this.readAttributeUnderscore("amount_off")
  }

  /** @returns {boolean} */
  hasAmountOff() {
    const value = this.amountOff()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  currency() {
    return this.readAttributeUnderscore("currency")
  }

  /** @returns {boolean} */
  hasCurrency() {
    const value = this.currency()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  duration() {
    return this.readAttributeUnderscore("duration")
  }

  /** @returns {boolean} */
  hasDuration() {
    const value = this.duration()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  durationInMonths() {
    return this.readAttributeUnderscore("duration_in_months")
  }

  /** @returns {boolean} */
  hasDurationInMonths() {
    const value = this.durationInMonths()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  maxRedemptions() {
    return this.readAttributeUnderscore("max_redemptions")
  }

  /** @returns {boolean} */
  hasMaxRedemptions() {
    const value = this.maxRedemptions()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  percentOff() {
    return this.readAttributeUnderscore("percent_off")
  }

  /** @returns {boolean} */
  hasPercentOff() {
    const value = this.percentOff()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  redeemBy() {
    return this.readAttributeUnderscore("redeem_by")
  }

  /** @returns {boolean} */
  hasRedeemBy() {
    const value = this.redeemBy()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  timesRedeemed() {
    return this.readAttributeUnderscore("times_redeemed")
  }

  /** @returns {boolean} */
  hasTimesRedeemed() {
    const value = this.timesRedeemed()

    return this._isPresent(value)
  }

  /** @returns {boolean | null} */
  stripeValid() {
    return this.readAttributeUnderscore("stripe_valid")
  }

  /** @returns {boolean} */
  hasStripeValid() {
    const value = this.stripeValid()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  created() {
    return this.readAttributeUnderscore("created")
  }

  /** @returns {boolean} */
  hasCreated() {
    const value = this.created()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  stripeId() {
    return this.readAttributeUnderscore("stripe_id")
  }

  /** @returns {boolean} */
  hasStripeId() {
    const value = this.stripeId()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static createOnStripe(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "create_on_stripe",
        collectionName: "stripe_coupons",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static durationCollection(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "duration_collection",
        collectionName: "stripe_coupons",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static validateCode(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "validate_code",
        collectionName: "stripe_coupons",
        type: "collection"
      },
      commandArgs
    ))
  }
}
